import React from 'react';
import { Empty, Table, Button, Flex, message, Modal } from 'antd';
import OrderCard from './card';
import TimesCard from '../promotion/goods-card/card';
import dayjs from 'dayjs';

const { Column } = Table;

export default () => {
    const params = new URLSearchParams(window.location.search);
    const shopId = params.get('shopId');
    const orderId = params.get('orderId');

    const [item, setItem] = React.useState(null);
    const { refundStatus } = item || {};

    React.useEffect(() => {
        console.log('orderId', orderId, shopId);
        if(orderId && shopId) {
            loadOrderDetail();
        }
    }, []);

    const getOrderDetail = async (params) => {
        const res = await fetch(`/api/order/detail?${new URLSearchParams(params)}`);
        const result = await res.json();
        return result;
    }

    const loadOrderDetail = () => {
        getOrderDetail({orderId, shopId}).then(res => {
            setItem(res.data);
        })
    }

    const handleRefund = (type) => {
        const text = type === 'refuse' ? '拒绝' : '同意';
        Modal.confirm({
            title: `确认${text}退款`,
            // okText: '确认',
            // cancelText: '取消',
            onOk: async () => {
                refund(type);
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        })
    }

    const refund = async (type) => { 
        const response = await fetch('/api/order/refund', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                orderId,
                type,
                shopId
            })
        });

        const res = await response.json();

        if(res && res.success) {
            message.success('操作成功');
        } else {
            message.error('退款失败');
        }
    }

    return (
        <div>
            <h2>订单详情</h2>
            {
                item ? <OrderCard onFlowChange={loadOrderDetail} content={item} style={{minWidth: 360, marginBottom: 10, maxWidth: 456, width: '100%'}} /> : <Empty />
            }
            <div>
                {
                    refundStatus === 3 && <Flex gap={10}>
                        <Button onClick={() => handleRefund('agree')}>同意退款</Button>
                        <Button onClick={() => handleRefund('refuse')}>拒绝退款</Button>
                    </Flex>
                }
            </div>
            {
                item?.timesCard && <div>
                    <h3>次卡信息</h3>
                    <TimesCard content={item.timesCard} />
                </div>
            }
            <h3>支付记录</h3>
            {
                item?.pays?.length ? <Table dataSource={item.pays} pagination={false}>
                    <Column title="支付时间" dataIndex="payTime" render={(text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')} />
                    <Column title="支付金额" dataIndex="amount" render={(text) => <>{text/100} 元</>} />
                    <Column title="详情" render={(text, record) => <a href={`/pay/detail?payId=${record.payId}`}>查看</a>} />
                </Table>
                : <Empty />
            }
        </div>
    )
}